import { Container } from "unstated";
//
export default class AppState extends Container {
  state = {
    headerOpen: false,
    navState: null
  };

  setNavState = navState => {
    this.setState({
      ...this.state,
      navState: this.state.navState !== navState ? navState : "forceclosed"
    });
  };

  closeHeader = () => {
    this.setState({
      ...this.state,
      headerOpen: false
    });
  };

  toggleHeader = () => {
    this.setState({
      ...this.state,
      headerOpen: !this.state.headerOpen
    });
  };
}
